export class Configs {

    constructor(
        public accessTokenExpiration?: string,
        public refreshTokenExpiration?: string,
        public gtoMaxFileSize?: string,
        public gtoUploadDir?: string,
        public gtoUploadUrl?: string,
        public webservicePortalUrl?: string,
        public webservicePortalOdoUrl?: string,
        public webservicePrestadorUrl?: string,
        public docuwareUrl?: string,
        public correiosUrl?: string
    ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/configs.ts